export default __webpack_public_path__ + "static/media/Path 53.62710c4f.svg";